import PackagesModal from './PackagesModal';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Actions
import { setApptServicePoint } from 'store/reducers/appointment/actions';
import { updateReadOnlyPackage } from 'store/reducers/packages/actions';

// Selectors
import { getServicePoint } from 'store/reducers/packages/selectors';
import {
  getServicePoint as getApptServicePoint,
  getApptMenuType
} from 'store/reducers/appointment/selectors';
import { getExpandedServicesView } from 'store/reducers/dealerSettings/selectors';
import { getActivePromotion } from 'store/reducers/promotions/selectors';
import {
  getIsQuoteAppt,
  getReadOnlyPackage
} from 'store/reducers/quoteAppt/selectors';

const mapStateToProps = state => ({
  servicePoint: getServicePoint(state),
  apptServicePoint: getApptServicePoint(state),
  servicesExpanded: getExpandedServicesView(state),
  apptMenuType: getApptMenuType(state),
  activePromotion: getActivePromotion(state),
  isQuoteAppt: getIsQuoteAppt(state),
  readOnlyPackage: getReadOnlyPackage(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setApptServicePoint, updateReadOnlyPackage }, dispatch);

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(PackagesModal);



// WEBPACK FOOTER //
// ./src/components/molecules/PackagesModal/PackagesModalContainer.js